import React from 'react';
import { GlobeIcon, InstagramIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-surface px-5 py-14 sm:px-8" data-id="element-108" data-mp="3gfiu2hdxs9dl">
      <div className="mx-auto max-w-4xl text-center" data-id="element-109" data-mp="3gh3ng3oilm9v">
        <p className="text-2xl font-extrabold uppercase tracking-[0.2em] text-gold" data-id="element-110" data-mp="32p5lqdx4usnq">
          🏋️ Núcleo Fit
        </p>
        <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-neutral-400" data-id="element-111" data-mp="36ppn5toqoifo">
          El sistema de entrenamiento N°1 para definición inteligente en
          Argentina. Porque bajar grasa y construir abdomen no debería
          complicarte todos los domingos del año.
        </p>

        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm" data-id="element-112" data-mp="3le2j4qntu1a6">
          <li data-id="element-113" data-mp="3qblwlocpaa12">
            <a href="mailto:soporte.nucleofit@gmail.com" className="inline-flex items-center gap-2 text-neutral-300 transition-colors duration-150 ease-out hover:text-gold focus:outline-none focus-visible:ring-2 focus-visible:ring-gold/50" data-id="element-114" data-mp="3qfjey7rgexjw">
              <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-115" data-mp="3l9sk795mt0ql" />
              soporte.nucleofit@gmail.com
            </a>
          </li>
          <li data-id="element-116" data-mp="3v7gejxzbs688">
            <a href="https://www.nucleofit.shop" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-neutral-300 transition-colors duration-150 ease-out hover:text-gold focus:outline-none focus-visible:ring-2 focus-visible:ring-gold/50" data-id="element-117" data-mp="3v89eog3s3xhe">
              <GlobeIcon className="h-4 w-4" aria-hidden="true" data-id="element-118" data-mp="32w2lsidfaa9" />
              www.nucleofit.shop
            </a>
          </li>
          <li data-id="element-119" data-mp="hs1xj4a6eecc">
            <a href="https://www.instagram.com/nucleofit_" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-neutral-300 transition-colors duration-150 ease-out hover:text-gold focus:outline-none focus-visible:ring-2 focus-visible:ring-gold/50" data-id="element-120" data-mp="huwlh5seehai">
              <InstagramIcon className="h-4 w-4" aria-hidden="true" data-id="element-121" data-mp="tvd0pv9a0bgq" />
              @nucleofit_
            </a>
          </li>
        </ul>

        <p className="mt-8 border-t border-line pt-8 text-xs leading-relaxed text-neutral-500" data-id="element-122" data-mp="yuzec5t0ntq2">
          © Núcleo Fit 2026 — Todos los derechos reservados. Prohibida la
          reproducción y redistribución sin autorización expresa.
        </p>
        <p className="mt-4 text-xs italic text-neutral-500" data-id="element-123" data-mp="1clmd1xys1jm5">
          💪 “La próxima semana puede empezar hoy.”
        </p>
      </div>
    </footer>;
}